import { ReactNode } from "react";
import Label from "react-bootstrap/Form";
import styled from "styled-components";

//App
import { pageHeaderLabelStyles } from "./styles";

const StyledLabel = styled(Label)`
  ${pageHeaderLabelStyles}
`;

const PageHeader = ({ children }: { children: ReactNode }) => {
  return <StyledLabel>{children}</StyledLabel>;
};

export default PageHeader;
